import _ from "lodash";
import React from "react";
import classes from "./MiddleBody.scss";
import { connect } from "react-redux";
import CurrentRating from "./CurrentRating";
import HistoryGraph from "./HistoryGraph";
import withLoader from "UIComponents/GqlWithLoader";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import Accordian from "UIComponents/Accordian";
import {
  goToPlatformHomeFeatureRoute,
  goToPlatformHomeChildRoute,
} from "modules/NavigationModule";
import { openLinkInNewTab } from "modules/Services";
import { gotoAssessmentDetails } from "Assessments/modules/AssessmentModule";
import { graphql, compose } from "lib/apolloClient";
import { getStudentsPypElementRatingHistoryQuery } from "ClassProgressSummary/modules/ClassProgressSummaryQuery";
import { getStudentsPypElementRatingHistoryFromCache } from "ClassProgressSummary/modules/ClassProgressSummaryGraphqlHelpers";
import { PostDetail } from "Post";
import { EmptyGradingHistory } from "SvgComponents";
import { deleteIBPYPElementRatingById } from "ClassProgressSummary/modules/ClassProgressSummaryModule";
import { getIsNotFromStudentPortfolio } from "StudentPortfolio/modules/StudentPortfolioUtils";
import { getOrganizationAcademicYearsWithTermsQuery } from "AcademicYearTerms/modules/Query";
import {
  getOrganizationId,
  getSelectedAcademicYearId,
} from "modules/CommonSelectors";

import { CURRICULUM_TYPE_UBD } from "Constants/stringConstants";
import { fontStyle } from "Constants";
import { getCurriculumProgramIdFromState, getYearDurationFormat } from "Utils";
import TermWiseHistoryList from "./TermWiseHistoryList";
import {
  getRatingHistoryQueryVariables,
  getIsMultiTermReport,
} from "ProgressReportCommon/utils";

const styles = {
  accordianHeaderStyle: {
    padding: "8px 0px",
  },
  headerStyle: { padding: "8px 0px" },
  mainContentContainerStyle: { marginBottom: "0px" },
};

const getLatestAcademicTerm = ({ academicTerms }) => {
  return _.first(
    _.orderBy(academicTerms, ["endDate", "startDate"], ["desc", "asc"])
  );
};

const isUnitLearningGoal = ({ isMultiTermReport, node }) => {
  const parentType = _.get(node, "parentType", "");
  return isMultiTermReport && parentType == "unit";
};

const getEndDateVariable = ({
  endDate,
  associatedProgressReportTermEndDate,
  academicTerms,
  node,
  isMultiTermReport,
  termIdForMultiTermReport,
}) => {
  if (isUnitLearningGoal({ isMultiTermReport, node })) {
    return {
      endDate: getLatestAcademicTerm({ academicTerms })?.endDate,
    };
  }
  if (isMultiTermReport) {
    return {
      endDate: _.get(
        _.find(academicTerms, ({ id }) => id == termIdForMultiTermReport),
        "endDate",
        ""
      ),
    };
  }
  return {
    endDate: !_.isEmpty(endDate)
      ? endDate
      : associatedProgressReportTermEndDate,
  };
};

const getTermIdForMultiTermReport = ({
  isMultiTermReport,
  academicTerms,
  academicTermId,
  node,
}) => {
  // In the case of rating history for units we are passing the latest academic term id for rating history
  // We are checking the parentType of the node to identify rating history for units
  if (isUnitLearningGoal({ isMultiTermReport, node })) {
    return _.get(getLatestAcademicTerm({ academicTerms }), "id", "");
  }
  return academicTermId;
};

const getElementTypeLabel = ({ t, elementType }) => {
  const mapping = {
    MYP_OBJECTIVES: t("common:lowercase", { text: t("common:criterion") }),
    MYP_ATL: t("common:lowercase", { text: t("common:skill") }),
    BENCHMARK: t("common:lowercase", { text: t("common:learning_outcome") }),
    MYP_SUBJECT: t("common:lowercase", { text: t("common:subject") }),
    CONCEPT: t("common:lowercase", { text: t("common:concept") }),
    ATL: t("common:lowercase", { text: t("common:skill") }),
    LEARNER_PROFILE: t("common:lowercase", {
      text: t("common:learner_profile"),
    }),
  };
  return mapping[elementType];
};
class MiddleBody extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      postId: null,
      showPostDetails: false,
    };
  }

  goToProgressReport = ({ parent }) => {
    const {
      userType,
      isFromStudentProfile,
      isNotFromStudentPortfolio,
      openLinkInNewTab,
      goToPlatformHomeChildRoute,
      goToPlatformHomeFeatureRoute,
    } = this.props;
    const studentReportId = _.get(parent, "id", "");
    const courseReportId = _.get(parent, "courseProgressReportTask.id", "");
    if (userType === "staff") {
      if (isFromStudentProfile && isNotFromStudentPortfolio) {
        openLinkInNewTab({
          url: `/platform/links/progress-report/${studentReportId}`,
        });
      } else {
        goToPlatformHomeFeatureRoute({
          route: `progressreport/${courseReportId}/${studentReportId}`,
          isOpenInNewTab: true,
        });
      }
      return;
    }
    goToPlatformHomeChildRoute({
      route: `progress-report/${studentReportId}`,
      isOpenInNewTab: true,
    });
  };

  goToStudentAssignment = ({ parent }) => {
    const { openLinkInNewTab } = this.props;
    const studentAssignmentId = _.get(parent, "id", "");
    const assignmentEvaluationId = _.get(parent, "assignment.id", "");
    openLinkInNewTab({
      url: `/platform/links/classroom-details/${assignmentEvaluationId}/mediamanager/${studentAssignmentId}?currentMedia=learningGoals`,
    });
  };

  onClickHistoryItem = ({ parentType, parent }) => {
    const { goToPlatformHomeFeatureRoute } = this.props;

    switch (parentType) {
      case "STUDENT_PROGRESS_REPORT": {
        this.goToProgressReport({ parent });
        break;
      }
      case "STUDENT_ASSESSMENT_EVALUATION": {
        const studentAssessmentEvaluationId = _.get(parent, "id", "");
        const assessmentEvaluationId = _.get(
          parent,
          "assessmentEvaluation.id",
          ""
        );
        goToPlatformHomeFeatureRoute({
          route: `assessmentEvaluation/${assessmentEvaluationId}/${studentAssessmentEvaluationId}`,
          isOpenInNewTab: true,
        });
        break;
      }
      case "POST": {
        const postId = _.get(parent, "id", "");
        this.setState({
          postId,
          showPostDetails: true,
        });
        break;
      }
      case "STUDENT_ASSIGNMENT": {
        this.goToStudentAssignment({ parent });
        break;
      }
    }
  };

  deleteRatingHistory = async params => {
    const { id } = params;
    const {
      deleteIBPYPElementRatingById,
      studentId,
      elementType,
      elementId,
      academicCriteriaSetId,
      endDate,
      subjectIds,
      curriculumType,
    } = this.props;

    this.setState({ isLoading: true });
    await deleteIBPYPElementRatingById({
      id,
      curriculumType,
      queryVariables: {
        studentId,
        academicCriteriaSetId,
        ibPYPElementId: elementId,
        ibPYPElementType: elementType,
        endDate,
        subjectIds: curriculumType == CURRICULUM_TYPE_UBD ? [] : subjectIds,
      },
    });
    this.setState({ isLoading: false });
  };

  render() {
    const {
      currentRating,
      ratingHistory,
      academicCriteriaSetId,
      isPopUp,
      elementType,
      showBasicHistoryList = false,
      t,
      canRemoveRating,
      showThumbnail = true,
      containerTitleStyle = {},
      academicYearToRatingMapping,
      academicYearsList,
      userType,
      termIdForMultiTermReport,
    } = this.props;

    const academicYearToRatingMappingKeys = _.keys(academicYearToRatingMapping);

    const filteredAcademicYearsList = _.filter(academicYearsList, ({ id }) =>
      _.includes(academicYearToRatingMappingKeys, id)
    );
    const orderedAcademicYearsList = _.orderBy(
      filteredAcademicYearsList,
      "startDate",
      "desc"
    );

    const { showPostDetails, postId, isLoading } = this.state;
    const elementTypeLabelText = getElementTypeLabel({ t, elementType });
    return (
      <React.Fragment>
        {isLoading && <FullScreenLoader />}
        {_.isEmpty(ratingHistory) && isPopUp ? (
          <div className={classes.emptyPopUpContainer}>
            <div className={classes.containerTitle} style={containerTitleStyle}>
              {t("progressSummary:grading_history")}
            </div>
            <div className={classes.emptyPopUpIcon}>
              <EmptyGradingHistory />
            </div>
            <div className={classes.emptyPopUpText}>
              {t("progressSummary:no_grading_history_with_label", {
                element_type_label: elementTypeLabelText,
              })}
            </div>
          </div>
        ) : (
          <div className={classes.container}>
            {!isPopUp ? (
              <CurrentRating currentRating={currentRating} />
            ) : (
              <div
                className={classes.containerTitle}
                style={containerTitleStyle}
              >
                {t("progressSummary:evaluation_history")}
              </div>
            )}
            <HistoryGraph
              academicCriteriaSetId={academicCriteriaSetId}
              ratingHistory={ratingHistory}
              isPopUp={isPopUp}
            />
            <div className={classes.historyListContainer}>
              {_.map(
                orderedAcademicYearsList,
                ({
                  id: academicYearId,
                  terms,
                  startDate,
                  endDate,
                  isCurrentAcademicYear,
                }) => {
                  const year = getYearDurationFormat({ startDate, endDate });
                  return (
                    <div
                      className={classes.accordianContainer}
                      key={academicYearId}
                    >
                      <Accordian
                        title={`${t("common:academic_year")} ${year}`}
                        isExpanded={isCurrentAcademicYear}
                        getExpandedContent={() => (
                          <TermWiseHistoryList
                            ratingHistory={
                              academicYearToRatingMapping[academicYearId]
                            }
                            isPopUp={isPopUp}
                            canRemoveRating={canRemoveRating}
                            showThumbnail={showThumbnail}
                            onClickHistoryItem={this.onClickHistoryItem}
                            deleteRatingHistory={this.deleteRatingHistory}
                            showBasicHistoryList={showBasicHistoryList}
                            userType={userType}
                            type={"addObservationPopoverHistoryList"}
                            terms={terms}
                            termIdForMultiTermReport={termIdForMultiTermReport}
                          />
                        )}
                        hideContainerBorder={true}
                        showLabelBorder={false}
                        headerStyle={styles.headerStyle}
                        customTitleStyle={fontStyle.demiBold}
                        mainContentContainerStyle={
                          styles.mainContentContainerStyle
                        }
                      />
                    </div>
                  );
                }
              )}
            </div>

            {showPostDetails && (
              <UIModal isOpen={true} isFullScreen={true}>
                <PostDetail
                  postId={postId}
                  canOpenComment={false}
                  detailsContainerStyle={{
                    width: "540px",
                    maxWidth: "540px",
                    margin: "0 auto",
                  }}
                  mediaMaxWidth={540}
                  onCloseClick={() => {
                    this.setState({ showPostDetails: false });
                  }}
                  isSidePaneContent={true}
                  isViewFromPostPage={false}
                />
              </UIModal>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapActionCreators = {
  gotoAssessmentDetails,
  goToPlatformHomeFeatureRoute,
  deleteIBPYPElementRatingById,
  goToPlatformHomeChildRoute,
  openLinkInNewTab,
};

const mapStateToProps = (state, ownProps) => {
  const {
    learningGoalsRatingEndDate,
    academicTermId,
    academicCriteriaSetId,
    elementId,
    elementType,
    curriculumType,
    subjectIds,
    gradingPeriodType,
    studentId,
    academicTerms = [],
    node = {},
    isMypCriteriaRatings,
  } = ownProps;
  const userType = _.get(state, "login.userInfo.user_type");
  const organizationId = getOrganizationId(state);
  const source = _.get(state, "studentPortfolio.studentProfileSource");
  const curriculumProgramId = getCurriculumProgramIdFromState({ state });
  const isNotFromStudentPortfolio = getIsNotFromStudentPortfolio({
    userType,
    source,
  });

  const isMultiTermReport = getIsMultiTermReport({
    gradingPeriodType,
  });

  const termIdForMultiTermReport = getTermIdForMultiTermReport({
    isMultiTermReport,
    academicTerms,
    academicTermId,
    node,
  });

  const reportAcademicTermId = _.get(
    state,
    "progressReport.academicTermId",
    null
  );
  const selectedAcademicYearId = getSelectedAcademicYearId(state);

  const updatedSubjectIds =
    curriculumType == CURRICULUM_TYPE_UBD ? [] : subjectIds;

  // Check if rating history is from MYP objectives or not

  const studentsPypElementRatingHistoryVariables = getRatingHistoryQueryVariables(
    {
      studentId,
      academicCriteriaSetId,
      elementId,
      elementType,
      updatedSubjectIds,
      isMultiTermReport,
      termIdForMultiTermReport,
      curriculumProgramId,
      isMypCriteriaRatings,
      learningGoalsRatingEndDate,
    }
  );

  return {
    isData: true,
    isLoading: false,
    showLoaderBar: false,
    endDate: learningGoalsRatingEndDate,
    userType,
    isNotFromStudentPortfolio,
    organizationId,
    academicTermId: reportAcademicTermId,
    selectedAcademicYearId,
    studentsPypElementRatingHistoryVariables,
    academicTerms,
    isMultiTermReport,
    termIdForMultiTermReport,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["progressSummary", "common"] }),
  graphql(getOrganizationAcademicYearsWithTermsQuery, {
    name: "getOrganizationAcademicYearsWithTerms",
    options: ({ organizationId }) => {
      return {
        variables: {
          id: organizationId,
        },
        fetchPolicy: "cache-and-network",
      };
    },
    props: ({
      getOrganizationAcademicYearsWithTerms,
      ownProps: { academicTermId, isData, isLoading },
    }) => {
      const academicYearsList = _.get(
        getOrganizationAcademicYearsWithTerms,
        "node.academicYears",
        []
      );

      // Only show history of current academic year associated with report term for MYP criteria ratings
      const academicYearAssociatedWithReportTerm = _.find(
        academicYearsList,
        academicYear => _.some(academicYear.terms, { id: academicTermId })
      );
      const associatedProgressReportTerm = _.find(
        _.get(academicYearAssociatedWithReportTerm, "terms", []),
        ({ id }) => id == academicTermId
      );

      const associatedProgressReportTermEndDate = _.get(
        associatedProgressReportTerm,
        "endDate",
        undefined
      );

      return {
        academicYearsList,
        academicYearAssociatedWithReportTermId: _.get(
          academicYearAssociatedWithReportTerm,
          "id"
        ),
        associatedProgressReportTermEndDate,
        isData:
          !_.isEmpty(_.get(getOrganizationAcademicYearsWithTerms, "node")) &&
          isData,
        isLoading:
          getOrganizationAcademicYearsWithTerms["networkStatus"] == 1 ||
          getOrganizationAcademicYearsWithTerms["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getStudentsPypElementRatingHistoryQuery, {
    name: "getStudentsPypElementRatingHistory",
    options: ({
      studentsPypElementRatingHistoryVariables,
      associatedProgressReportTermEndDate,
      endDate,
      isMypCriteriaRatings,
      academicTerms = [],
      node,
      isMultiTermReport,
      termIdForMultiTermReport,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ...studentsPypElementRatingHistoryVariables,
        ...(!isMypCriteriaRatings
          ? getEndDateVariable({
              endDate,
              associatedProgressReportTermEndDate,
              academicTerms,
              node,
              isMultiTermReport,
              termIdForMultiTermReport,
            })
          : {}),
      },
    }),
    props({
      getStudentsPypElementRatingHistory,
      ownProps: {
        isData,
        isLoading,
        isMypCriteriaRatings,
        academicYearAssociatedWithReportTermId,
        selectedAcademicYearId,
      },
    }) {
      const data = _.get(
        getStudentsPypElementRatingHistoryFromCache(
          getStudentsPypElementRatingHistory.variables
        ),
        "node",
        {}
      );

      let ratingHistory = _.map(
        _.get(data, "ibPYPElementRatings", []),
        rating => {
          return {
            ...rating,
            academicCriteriaValue: _.get(
              rating.academicCriteriaValue,
              "id",
              ""
            ),
          };
        }
      );

      const shouldFilterRatingHistory =
        isMypCriteriaRatings || !_.isEmpty(selectedAcademicYearId);
      const academicYearId = isMypCriteriaRatings
        ? academicYearAssociatedWithReportTermId
        : selectedAcademicYearId;

      if (shouldFilterRatingHistory) {
        ratingHistory = _.filter(
          ratingHistory,
          rating => _.get(rating, "academicYear.id", null) == academicYearId
        );
      }

      const academicYearToRatingMapping = _.groupBy(
        ratingHistory,
        "academicYear.id"
      );

      const currentRating = _.get(
        ratingHistory.first(),
        "academicCriteriaValue",
        null
      );

      return {
        ratingHistory,
        currentRating,
        academicYearToRatingMapping,
        getStudentsPypElementRatingHistory,
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getStudentsPypElementRatingHistory["networkStatus"] == 1 ||
          getStudentsPypElementRatingHistory["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  withLoader
)(MiddleBody);
